import React from "react";
import { TemporarySections } from "./Temporary";
import { PermanentSections } from "./Permanent";    
import { ArcStack } from "@src/core/ui";
import { ZoneEntity } from "@src/core/features";


interface SectionsProps {
    temporaryZones: ZoneEntity[] | undefined;
    permanentZones: ZoneEntity[] | undefined;
}

export const NoFlySections: React.FC<SectionsProps> = (props) => {
  const { temporaryZones = [], permanentZones = [] } = props;
  return (
    <React.Fragment >
      <ArcStack my={2} spacing={1}>
        <TemporarySections zones={temporaryZones} />
      </ArcStack>
      <ArcStack marginTop={"1px"}>
        <PermanentSections zones={permanentZones} />
      </ArcStack>
    </React.Fragment>
  );
};  